import { Skeleton, Stack } from "@mui/material";

export function MapEditorObservationPanelSkeleton() {
    return (
        <Stack gap={1} padding={2}>
            <Skeleton height={24} />
            <Skeleton height={32} />
            <Skeleton height={24} />
            <Skeleton height={24} />
            <Skeleton height={24} />
        </Stack>
    );
}
